import { useTheme, useMediaQuery } from '@/theme/index';

// It has been decided that this method does not need a test. It is
// essentially just a wrapper around what should be rigorously tested
// React and MUI internals. Our implementation here hardly adds any logic
// or variability and testing seems unnecessary. Moreover, when we
// attempted to come up with a test suite for it, everything we tried
// was not working as expected so we dropped it. - NOH 10/2/23

export const useScreenSize = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isXL = useMediaQuery(theme.breakpoints.up('xl'));

  return { isMobile, isTablet, isDesktop, isMedium, isXL };
};
